import * as React from "react";
import { useState, useEffect, useRef } from "react";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
// import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
// import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";

import { Header } from "../Header";
import { Link } from "react-router-dom";

// import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
// import PhotoCameraFrontIcon from "@mui/icons-material/PhotoCameraFront";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";

import CopyrightIcon from "@mui/icons-material/Copyright";

// import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
// import SupportAgentIcon from "@mui/icons-material/SupportAgent";

import { useNavigate, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import MobileDrawer from "../MobileDrawer";
import UserService from "rc-app/services/UserService";
import { getAgencyLogo } from "rc-app/api/agencyActionsApi";
// import { determineAgencyType } from "rc-app/utils";
// import { getRegionIds } from "rc-app/api/regionActionsApi";
// import AgencyDetailsContext from "rc-app/context/AgencyDetailsContext/AgencyDetailsContext";
// import { Container } from '@mui/material';

import Slide from "@mui/material/Slide";

import { Outlet } from "react-router-dom";
// import MiniFooter from "../MiniFooter";
import Icon from "../Icons";

//props for content children
interface MiniDrawerProps {
  children?: React.ReactNode;
}

// for auto hide...
interface HideOnScrollProps {
  scrollContainer?: HTMLDivElement | null;
  children: React.ReactElement;
}
function HideOnScroll(props: HideOnScrollProps) {
  const { children, scrollContainer } = props;
  const [show, setShow] = React.useState(true);
  const [lastScrollY, setLastScrollY] = React.useState(0);

  React.useEffect(() => {
    if (!scrollContainer) return undefined;

    const handleScroll = () => {
      const currentScrollY = scrollContainer.scrollTop;

      // If at the top, always show the header
      if (currentScrollY <= 0) {
        setShow(true);
      }
      // If scrolling up, show the header
      else if (currentScrollY < lastScrollY) {
        setShow(true);
      }
      // If scrolling down, hide the header
      else if (currentScrollY > lastScrollY) {
        setShow(false);
      }

      setLastScrollY(currentScrollY);
    };

    scrollContainer.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      scrollContainer.removeEventListener("scroll", handleScroll);
    };
  }, [scrollContainer, lastScrollY]);

  return (
    <Slide appear={false} direction="down" in={show}>
      {children}
    </Slide>
  );
}

const drawerWidth = 240;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function MiniDrawer({ children }: MiniDrawerProps) {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  console.log(theme);

  const [open, setOpen] = useState(false);
  const scrollRef = useRef<HTMLDivElement>(null);
  const [scrollContainer, setScrollContainer] = useState<HTMLDivElement | null>(
    null,
  );

  useEffect(() => {
    if (scrollRef.current) {
      setScrollContainer(scrollRef.current);
    }
  }, []);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  }, [location.pathname]);

  const currentUrl = window.location.href;
  const url = new URL(currentUrl);
  const path = url.pathname;
  console.log("path", path);

  const { slug } = useParams<{ slug: string }>();

  const [agencyLogoUrl, setAgencyLogoUrl] = useState(null);
  const [selectedItem, setSelectedItem] = useState("My Projects");
  const [agencyName, setAgencyName] = useState("");

  useEffect(() => {
    // UserService.hasRole("agent") &&
    getAgencyLogo(UserService.getUseremail()).then(async (res) => {
      console.log("lklkklCustomer", res);
      setAgencyLogoUrl(res.logo);
      setAgencyName(res.agencyName);
      // Cache the agency logo so other pages (e.g. ProjectDetailsV3's
      // EntryLoader) can render it on first paint without waiting for an
      // agency fetch. Refreshes whenever this drawer re-mounts and re-fetches.
      try {
        if (res?.logo) localStorage.setItem("agencyLogo", res.logo);
      } catch { /* localStorage unavailable — silent */ }
    });
    // UserService.hasRole("customer") && setAgencyLogoUrl("string");
    // UserService.hasRole("customer") && setAgencyName("string");
  }, []);

  useEffect(() => {
    const pathname = location.pathname;

    console.log("clicked path", pathname);

    switch (pathname) {
      case "/":
      case "/agency_list":
        setSelectedItem("My Projects");
        break;
      case "/network_list":
        setSelectedItem("Network Listings");
        break;
      case "/customers":
        setSelectedItem("My Customers");
        break;
      case "/earnings":
        setSelectedItem("My Earnings");
        break;
      case "/vr_tour_list":
        setSelectedItem("My Virtual Tours");
        break;

      case "/profile":
        setSelectedItem("My Profile");
        break;

      case "/properties_shortlist":
        setSelectedItem("Properties Shortlist");
        break;
      case "/relationship_manager":
        setSelectedItem("Relationship Manager");
        break;
      case "/join_vr_tour":
        setSelectedItem("Join VR Tour");
        break;
      case "/my_agent":
        setSelectedItem("My Agent");
        break;

      default:
        setSelectedItem("");
    }
  }, [location.pathname]);

  const handleMenuItemClick = (item: any, path: any) => {
    setSelectedItem(item);
    navigate(path); // Assuming `navigate` is accessible here
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => setIsMobile(window.innerWidth < 1023);
    checkIsMobile();

    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  console.log("UserService", agencyLogoUrl);
  const hide = true;

  return (
    <Box
      sx={{
        display: "flex",
        // backgroundColor: "#2E4051",
        // position: "relative",
        // maxWidth: "1536px",
        height: "100vh",
      }}
    >
      <CssBaseline />
      <HideOnScroll scrollContainer={scrollContainer}>
        <AppBar position="fixed" open={open}>
          <Toolbar
            style={{
              backgroundColor: UserService.hasRole("super_admin")
                ? "#2E4051"
                : "#163F43",

              // 008564
            }}
          >
            {" "}
            {/* <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={() => {
                setOpen(!open);
              }}
              edge="start"
              sx={{
                // marginRight: 2,
                ...(open && { display: "none" }),
              }}
            >
              <MenuIcon />
            </IconButton> */}
            <Header drawerOpen={open} agencyName={agencyName} agencyLogo={agencyLogoUrl} />
            {/* <div
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                height: "3px",
                // zIndex: "",
                background: "linear-gradient(90deg, #4BA04A, #0987A8)",
              }}
            /> */}
          </Toolbar>
        </AppBar>
      </HideOnScroll>
      {hide ||
        (!isMobile && (
          // Adding Opensky logo
          <Drawer
            variant="permanent"
            open={open}
            sx={{
              "& .MuiDrawer-paper": {
                backgroundColor: "#2E4051",
                // color: "white", // Optional: change text color to white for better contrast
              },
            }}
          >
            <DrawerHeader
              sx={{
                paddingY: "0.4rem",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                  color: "white",
                }}
              >
                <Link
                  to="/"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  {/* Responsive Logo */}

                  {agencyLogoUrl == null ? (
                    // Show nothing while loading
                    <div className="flex w-36 h-12 " />
                  ) : (
                    // Show either agency logo or default logo
                    open && (
                      <img
                        alt="Opensky"
                        src={agencyLogoUrl || "/images/logoColoured.svg"}
                        // style={{
                        //   width: "clamp(40px, 15vw, 120px)",
                        //   height: "auto",
                        // }}
                        className="object-contain w-36 h-12 "
                      />
                    )
                  )}
                </Link>
              </div>
              <IconButton onClick={() => setOpen(!open)}>
                {!open ? (
                  <ChevronRightIcon sx={{ color: "white" }} />
                ) : (
                  <ChevronLeftIcon sx={{ color: "white" }} />
                )}
              </IconButton>
            </DrawerHeader>
            {UserService.hasRole("agent") && (
              <List className="opacity-80">
                {UserService.hasRole("agent") && (
                  <>
                    <ListItem disablePadding sx={{ display: "block" }}>
                      <Tooltip
                        title="My Projects"
                        placement="right"
                        disableHoverListener={open}
                      >
                        <ListItemButton
                          selected={selectedItem === "My Projects"}
                          sx={{
                            minHeight: 48,
                            justifyContent: open ? "initial" : "center",
                            px: 2.5,
                            "&.Mui-selected": {
                              backgroundColor: "#1C2C3A",
                            },
                            position: "relative",
                            // "&:hover": {
                            //   backgroundColor: "#1C2C3A",
                            // },
                          }}
                          onClick={() => {
                            handleMenuItemClick("My Projects", "/agency_list");
                            setOpen(false);
                          }}
                        >
                          <Icon
                            name="ic-home"
                            className="w-5 h-5 text-white cursor-pointer"
                            style={{ filter: "brightness(0) invert(1)" }}
                          />
                          <div className="w-2"></div>
                          {/* <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                          color: "#ffffff",
                          // selectedItem === "My Projects"
                          //   ? "#ffffff"
                          //   : "inherit",
                        }}
                      >
                        <FormatListBulletedIcon />
                      </ListItemIcon> */}

                          <ListItemText
                            primary="My Projects"
                            sx={{ opacity: open ? 1 : 0 }}
                            className={
                              selectedItem === "My Projects"
                                ? "text-white rounded-md font-normal text-base"
                                : "text-white"
                            }
                          />
                        </ListItemButton>
                      </Tooltip>
                    </ListItem>

                    <ListItem disablePadding sx={{ display: "block" }}>
                      <Tooltip
                        title="My Customers"
                        placement="right"
                        disableHoverListener={open}
                      >
                        <ListItemButton
                          selected={selectedItem === "My Customers"}
                          sx={{
                            minHeight: 48,
                            justifyContent: open ? "initial" : "center",
                            px: 2.5,
                            "&.Mui-selected": {
                              backgroundColor: "#1C2C3A",
                            },
                            position: "relative",
                            // "&:hover": {
                            //   backgroundColor: "#1C2C3A",
                            // },
                          }}
                          onClick={() => {
                            handleMenuItemClick("My Customers", "/customers");
                            setOpen(false);
                          }}
                        >
                          <Icon
                            name="ic-customers"
                            className="w-5 h-5 text-white cursor-pointer"
                            style={{ filter: "brightness(0) invert(1)" }}
                          />
                          <div className="w-2"></div>

                          <ListItemText
                            primary="My Customers"
                            sx={{ opacity: open ? 1 : 0 }}
                            className={
                              selectedItem === "My Customers"
                                ? "text-white rounded-md font-normal text-base"
                                : "text-white"
                            }
                          />
                        </ListItemButton>
                      </Tooltip>
                    </ListItem>
                  </>
                )}

                {UserService.hasRole("agent") && (
                  <ListItem disablePadding sx={{ display: "block" }}>
                    <Tooltip
                      title="My Profile"
                      placement="right"
                      disableHoverListener={open}
                    >
                      <ListItemButton
                        selected={selectedItem === "My Profile"}
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 2.5,
                          "&.Mui-selected": {
                            backgroundColor: "#1C2C3A",
                          },
                          position: "relative",
                          // "&:hover": {
                          //   backgroundColor: "#1C2C3A",
                          // },
                        }}
                        onClick={() => {
                          handleMenuItemClick("My Profile", slug ? `/c/${slug}/profile` : "/profile");
                          setOpen(false);
                        }}
                      >
                        <Icon
                          name="ic-account_circle"
                          className="w-5 h-5 text-white cursor-pointer"
                          style={{ filter: "brightness(0) invert(1)" }}
                        />
                        <div className="w-2"></div>
                        {/* <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                          color: "#ffffff",
                          // selectedItem === "My Projects"
                          //   ? "#ffffff"
                          //   : "inherit",
                        }}
                      >
                        <FormatListBulletedIcon />
                      </ListItemIcon> */}

                        <ListItemText
                          primary="My Profile"
                          sx={{ opacity: open ? 1 : 0 }}
                          className={
                            selectedItem === "My Profile"
                              ? "text-white rounded-md font-normal text-base"
                              : "text-white"
                          }
                        />
                      </ListItemButton>
                    </Tooltip>
                  </ListItem>
                )}
              </List>
            )}

            <Divider />
            <div
              className={` absolute bottom-[10px]  ${
                open
                  ? " inset-x-0 flex items-center justify-center flex-col"
                  : ""
              } `}
            >
              {open ? (
                <div className="flex items-center ">
                  <span className="text-[0rem] text-[#889DB2]">
                    {" "}
                    <CopyrightIcon />{" "}
                  </span>
                  <span className="text-[#889DB2] text-[1rem]">
                    {" "}
                    Powered by{" "}
                  </span>
                </div>
              ) : null}

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                {/* <img
                src="/images/logoColoured.svg"
                alt="Opensky"
                style={{
                  width: open ? "80px" : "60px", // Larger when open, smaller when closed
                  height: "auto", // Maintains aspect ratio
                  objectFit: "contain",
                }}
              /> */}

                <img
                  alt="Opensky"
                  // src="/images/logo.svg"
                  src={`${process.env.REACT_APP_UPLOADED_URL}/realestate/logo.png`}
                  className={`object-cover w-24 h-8 transition-opacity ${
                    open ? "opacity-100" : "opacity-0 w-0 h-0"
                  }`}
                />
              </div>
            </div>
          </Drawer>
        ))}
      {isMobile && <MobileDrawer open={open} setOpen={setOpen} />}

      <Box
        ref={scrollRef}
        component="main"
        sx={{
          flexGrow: 1,
          height: "100vh",
          overflow: "auto",
          pt: 8,
          backgroundColor: UserService.hasRole("super_admin")
            ? "#2E4051"
            : "#163F43",
          display: "flex",
          flexDirection: "column",
          // Themed scrollbar (replaces the default white one) — applies to
          // every page that scrolls through the app shell, e.g. ProjectDetails.
          // Wider bar + track illuminates on hover (GCP-style affordance).
          scrollbarColor: "#2C4D5A transparent",
          "&::-webkit-scrollbar": { width: "14px", height: "14px" },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
            transition: "background 0.15s ease",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#2C4D5A",
            borderRadius: "7px",
            border: "3px solid transparent",
            backgroundClip: "padding-box",
            transition: "background 0.15s ease",
          },
          "&:hover::-webkit-scrollbar-track": {
            background: "rgba(255,255,255,0.10)",
          },
          "&:hover::-webkit-scrollbar-thumb": {
            background: "#3D5468",
            backgroundClip: "padding-box",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "#4A6075",
            backgroundClip: "padding-box",
          },
        }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Outlet />
        </Box>
        {/* <footer className="bg-[#000630] relative">
          <MiniFooter />
        </footer> */}
      </Box>
    </Box>

    // </Container>
  );
}
